// extracted by mini-css-extract-plugin
module.exports = {"item":"TagUserInput_item__1Sp8z","selected":"TagUserInput_selected__2RWgY"};